export const PASSWORD_RESTORE = 'restore-pass-page/PASSWORD_RESTORE';
export const PASSWORD_RESTORE_SUCCESS = 'restore-pass-page/PASSWORD_RESTORE_SUCCESS';
export const PASSWORD_RESTORE_FAIL = 'restore-pass-page/PASSWORD_RESTORE_FAIL';

export const VALIDATE_RESTORE_TOKEN = 'restore-pass-page/VALIDATE_RESTORE_TOKEN';
export const VALIDATE_RESTORE_TOKEN_SUCCESS = 'restore-pass-page/VALIDATE_RESTORE_TOKEN_SUCCESS';
export const VALIDATE_RESTORE_TOKEN_FAIL = 'restore-pass-page/VALIDATE_RESTORE_TOKEN_FAIL';
